module.exports = __webpack_public_path__ + "img/smg47_samurai02_shop.951049aa.png";